<template>
  <v-card class="application-item">
    <v-toolbar color="teal darken-4" dark>
      <v-toolbar-side-icon left>{{application.application_type.acronym}}</v-toolbar-side-icon>
      <v-toolbar-title>{{application.application_type.name}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon title="Excluir" v-on:click="dialog = true"
             v-if="validations()">
        <v-icon>mdi-delete</v-icon>
      </v-btn>

      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Deseja remover esse requerimento?</v-card-title>
          <v-card-text>Após remover um requerimento, todos os
            documentos já enviados serão removidos.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click="dialog = false">Não</v-btn>
            <v-btn color="green darken-1" flat @click="removeApplication()">Sim</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-toolbar>

    <v-list two-line subheader>
      <v-list-tile avatar @click="showApplication(application)">
        <v-list-tile-avatar>
          <v-icon>{{ personalTypeIcon }}</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>{{ application.person.name }}</v-list-tile-title>
          <v-list-tile-sub-title>
            {{ processCpfCnpj }}
          </v-list-tile-sub-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <small class="badge grey">Aguardando envio</small>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
  </v-card>
</template>

<script>
import ApplicationService from '@/services/applications/ApplicationService';

export default {
  name: 'WaitingToBeSentApplication',
  props: {
    application: {
      type: Object,
      default: () => {},
    },
    personalTypeIcon: {
      type: String,
      default: '',
    },
    processCpfCnpj: {
      type: String,
      default: '',
    },
    dialog: {
      typo: Boolean,
      default: false,
    },
  },
  methods: {
    validations() {
      return this.application.folder_number == null &&
        this.application.payment_slips[0].payment_status === false;
    },
    removeApplication() {
      this.$store.dispatch('setLoadingDialog', true);
      ApplicationService
        .destroy(this.application.id)
        .then(() => {
          this.$swal({
            type: 'success',
            titleText: 'Requerimento removido com sucesso!',
          });
        })
        .catch((err) => {
          this.$swal({
            type: 'error',
            titleText: `${err.response.data.join('\n')}`,
          });
        })
        .finally(() => {
          this.dialog = false;
          this.$store.dispatch('setLoadingDialog', false);
        });
    },
    showApplication(application) {
      this.$store.dispatch('setLoadingDialog', true);
      this.$router.push(`${application.id}/visualizar`);
    },
  },
};
</script>
